import { Grid, Box, Text } from '@simplywallst/ui-core';

import { currencyToSymbol } from '@/utilities/formatting';
import { CompanyIntrinsicDiscount } from '@/components/CompanyIntrinsicDiscount';

import type { NarrativeValuationCompany } from '../../../hooks/useNarrativeValuationCompany';
import { FairValueInput } from './FairValueInput';
import { getTradingItemCurrencyISO } from '@/utilities/getTradingItemCurrencyISO';

export type Props = {
  company: NarrativeValuationCompany;
  onChange: (fairValue: number) => void;
  fairValue: number;
};

export const NarrativeValuatorCalculation = ({
  company,
  onChange,
  fairValue,
}: Props) => {
  const companyCurrencySymbol = currencyToSymbol[
    getTradingItemCurrencyISO(company.data.currencyInfo) ?? ('XXX' as const)
  ].currency.symbol as string;

  return (
    <Grid
      backgroundColor="spaceGray"
      borderTopLeftRadius="x1"
      borderTopRightRadius="x1"
    >
      <Box paddingX="x2" paddingTop="x2">
        <Text as="span" typography="xSmallStrong" color="textSolid">
          <label htmlFor="narrative-valuator-fair-value">Fair Value</label>
        </Text>
      </Box>
      <Box padding="x2">
        <Grid gap="12px" templateColumns="1fr auto">
          <FairValueInput
            currencySymbol={companyCurrencySymbol}
            onChange={onChange}
            value={fairValue}
          />
          <Grid
            as="span"
            templateColumns="auto auto"
            alignItems="center"
            gap="2px"
          >
            <Text as="span" color="textSolid">
              <CompanyIntrinsicDiscount
                lastSharePrice={company.analysisValue?.lastSharePrice ?? null}
                npvPerShare={company.analysisValue?.npvPerShare ?? null}
                fairValue={fairValue}
              />
            </Text>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};
